import { FILTERS, DEFAULT_FILTER_OPTIONS } from '../../../../../common/filters/constants';
import { getBeginningOfDay, getCurrentMoment } from '../../../../../../constants/helpers/dates';

import { AirtimeBillingFilters } from './interfaces';

export const initFilters: AirtimeBillingFilters = {
  [FILTERS.PAGE_SIZE]: DEFAULT_FILTER_OPTIONS.PAGE_SIZE,
  [FILTERS.FROM]: getBeginningOfDay(),
  [FILTERS.TO]: getCurrentMoment(),
  [FILTERS.OPERATION_ID]: [],
  [FILTERS.STATUS]: [],
  [FILTERS.OPERATOR]: [],
  [FILTERS.SKU]: [],
  [FILTERS.ACQUIRER_MSISDN]: []
};

export const activeFiltersCountMapper = (activeFilters: AirtimeBillingFilters) => {
  let availableFiltersCount = 0;

  if (activeFilters.operation_id?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.status?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.operator?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.sku?.length > 0) {
    availableFiltersCount += 1;
  }

  return availableFiltersCount;
};
